module.exports = __webpack_public_path__ + "static/media/Data Asset Builder Main.5f8e8be3.svg";